export default __webpack_public_path__ + "static/EXP_Pressemeldung_1_1_de-2e793a4e645df03f8c3ab9fbd8f27e09.jpg";